import { requireAuthOrProspectEmail } from '../guards';

export const path = '/:product?/games/:gameId/join';
export const component = 'StartGameOrder';
export const thunk = () => requireAuthOrProspectEmail;
